module.exports = __webpack_public_path__ + "img/benefits.e06b5cb3.svg";